<div #turnstileContainer [style.display]="mode === 'invisible' ? 'none' : 'block'"></div>
